import React from 'react';

import RegularRate from '../rates/RegularRate.jsx';

const MultiOutcome = ({section, outcome, gridLocalization}) => {
    const outcomeRates = [];

    outcome.get('rates')
        .entrySeq()
        .sortBy((r) => r[0])
        .forEach((r) => {
            outcomeRates.push(r[1]);
        });

    const props = {
        section,
        gridLocalization
    };

    return (
        <div className="rates">
            {outcomeRates.map((r) => <RegularRate key={r} id={r} {...props}/>)}
        </div>
    );
};

MultiOutcome.propTypes = {
    section: React.PropTypes.string.isRequired,
    outcome: React.PropTypes.object.isRequired,
    gridLocalization: React.PropTypes.object.isRequired
};

export default MultiOutcome;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/outcomes/MultiOutcome.jsx